module.exports = __webpack_public_path__ + "img/home.ebcbdb78.svg";